import React from "react";
import { Tr, Td } from "@chakra-ui/react";

const ResponsiveRow = ({ cells }) => {
  const showLayout = () => {
    return cells.map((cell, index) => (
      <Td key={index} style={{ ...cell.tdStyle, overflow: "visible" }}>
        {cell.item}
      </Td>
    ));
  };

  return <Tr>{showLayout()}</Tr>;
};

export default ResponsiveRow;
